var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgThumbsUpOutline28 = function SvgThumbsUpOutline28(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    fill: "none",
    viewBox: "0 0 28 28"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9ED",
    d: "M5 24a1 1 0 1 1-2 0V12a1 1 0 1 1 2 0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#00D9ED",
    fillRule: "evenodd",
    d: "M13.081 4c-.548 0-1.048.316-1.282.812L9.353 9.98A3.7 3.7 0 0 0 9 11.549V20.5a2.5 2.5 0 0 0 2.5 2.5h7.009a2.5 2.5 0 0 0 2.323-1.576l2.982-7.5a2.5 2.5 0 0 0-2.323-3.424h-5.609A1.38 1.38 0 0 1 14.5 9.118v-3.7C14.5 4.636 13.865 4 13.081 4m-3.09-.044A3.419 3.419 0 0 1 16.5 5.42V8.5h4.991c3.18 0 5.357 3.208 4.182 6.163l-2.983 7.5A4.5 4.5 0 0 1 18.51 25H11.5A4.5 4.5 0 0 1 7 20.5v-8.951c0-.839.186-1.667.545-2.425z",
    clipRule: "evenodd"
  })));
};
export default SvgThumbsUpOutline28;